import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import DesktopHeader from 'srcReact/OrganizationSettingsPage/components/DesktopHeader'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { isMobileScreen } from 'srcReact/helpers/utils'
import { integrationActions } from '../../actions'
import styles from '../../styles.module.scss'
import IntegrationButton from '../IntegrationButton'

function OrgIntegrations() {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const isMobileDevice = isMobileScreen()
  const [orgId, setOrgId] = useState(0)
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)

  const {
    integration: { availableIntegrations, deleteIntegration }
  } = useSelector((state) => state)

  useEffect(() => {
    const organizationId = getCurrentOrgId()
    setOrgId(organizationId)
    dispatch(integrationActions.getAvailableOrgConnections(organizationId))
  }, [])

  useEffect(() => {
    if (isConfirmModalOpen && !deleteIntegration.loading && deleteIntegration.success) {
      closeConfirmModal()
    }
  }, [deleteIntegration])

  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false)
  }

  return (
    <React.Fragment>
      {!isMobileDevice && <DesktopHeader title={t('integration.title2')} subtitle={t('integration.subTitle2')} />}
      <div className={styles.integrationWrapper}>
        <div className={styles.activeIntegrations}></div>
        <div className={styles.availableIntegrations}>
          {/* <h3 className={styles.title}>{t('integration.availableIntegrations')}</h3> */}
          <div className={styles.videocalling}>
            <h4 className={styles.subTitle}>{t('integration.videoCalling')}</h4>
            <div className={styles.list}>
              {availableIntegrations?.list
                ?.filter((api) => api.usage === 'virtual_meeting')
                .map((api) => {
                  const imageType =
                    api.external_api === 'google'
                      ? `google_meet_${isMobileDevice ? 'small' : 'full'}`
                      : api.external_api === 'microsoft'
                      ? `ms_teams_${isMobileDevice ? 'small' : 'full'}`
                      : api.external_api === 'zoom'
                      ? 'zoom'
                      : ''

                  return (
                    <IntegrationButton
                      size='large'
                      isActive={api.is_active === 1}
                      isButton={false}
                      from='org_settings'
                      orgId={orgId}
                      imageType={imageType}
                      integrationType={api.external_api}
                      usage={api.usage}
                    />
                  )
                })}
            </div>
          </div>
          <div className={styles.calendars}>
            <h4 className={styles.subTitle}>{t('integration.calendars')}</h4>
            <div className={styles.list}>
              {availableIntegrations?.list
                ?.filter((api) => api.usage === 'add_to_calendar')
                .map((api) => {
                  const imageType =
                    api.external_api === 'google'
                      ? `google_cal_${isMobileDevice ? 'small' : 'full'}`
                      : api.external_api === 'microsoft'
                      ? `outlook_${isMobileDevice ? 'small' : 'full'}`
                      : ''
                  return (
                    <IntegrationButton
                      size='large'
                      isActive={api.is_active === 1}
                      from='org_settings'
                      isButton={false}
                      orgId={orgId}
                      imageType={imageType}
                      integrationType={api.external_api}
                      usage={api.usage}
                    />
                  )
                })}
            </div>
          </div>

          <div className={styles.translation}>
            <h4 className={styles.subTitle}>{t('integration.translation')}</h4>
            <div className={styles.list}>
              {availableIntegrations?.list
                ?.filter((api) => api.usage === 'translate')
                .map((api) => {
                  return (
                    <IntegrationButton
                      size='large'
                      isActive={api.is_active === 1}
                      from='org_settings'
                      isButton={false}
                      orgId={orgId}
                      imageType='translate'
                      integrationType={api.external_api}
                      usage={api.usage}
                    />
                  )
                })}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default OrgIntegrations
